import * as React from 'react';
import { Grid, Typography, ButtonGroup, CircularProgress, Button } from '@material-ui/core';
import { SelectItem } from '../../../../ui-components/select/Select';
import clsx from 'clsx';
import PrevButton from '../../../../ui-components/Button/PrevButton';
import moment from 'moment';
import NextButton from '../../../../ui-components/Button/NextButton';

interface IProps {
    roomSelected: SelectItem;
    dayView: Date;
    filterDate: Date;
    setFilterDate: (day: Date) => void;
    viewType: "day" | "week";
    updateViewType: (viewType: "day" | "week") => void;
    nextDayWeek: () => void;
    prevDayWeek: () => void;
    classes: any;
    smallScreen: boolean;
    disabledChangeDay: boolean;
    disabled: boolean;
}

// eslint-disable-next-line import/no-anonymous-default-export
export default (props: IProps) => {
    return (
        <Grid container style={{ alignItems: "center" }}>
            <Grid item>
                <ButtonGroup color="secondary">
                    <Button
                        disabled={props.disabled}
                        className={clsx({ [props.classes.GroupButtonSelected]: props.viewType === "day" }, { [props.classes.GroupButtonNotSelected]: props.viewType !== "day" })}
                        onClick={() => props.updateViewType("day")}>Giorno</Button>
                    <Button disabled={props.disabled}
                        className={clsx({ [props.classes.GroupButtonSelected]: props.viewType === "week" }, { [props.classes.GroupButtonNotSelected]: props.viewType !== "week" })}
                        onClick={() => props.updateViewType("week")}>Settimana</Button>
                </ButtonGroup>
            </Grid>
            {props.roomSelected !== undefined &&
                <Grid item style={{ justifyContent: "center" }}
                    className={props.smallScreen ? props.classes.SmallSearchSection : props.classes.SearchSection}>
                    {props.disabled ?
                        <Grid container style={{ width: "100%", justifyContent: "center" }}>
                            <CircularProgress /><Typography className={props.classes.Typography}>Aggiornamento...</Typography>
                        </Grid>
                        :
                        <Grid container style={{ width: "100%", justifyContent: "center" }}>
                            {props.viewType === "week" &&
                                <Grid style={{ display: "flex", alignItems: "center" }}>
                                    <PrevButton
                                        disabled={props.disabledChangeDay}
                                        onClick={() => {
                                            props.prevDayWeek()
                                        }} />
                                    <Typography className={props.classes.Typography}>Dal {moment(props.dayView).startOf("week").format("DD MMMM YYYY")} al {moment(props.dayView).endOf("week").format("DD MMMM YYYY")}</Typography>
                                    <NextButton
                                        disabled={props.disabledChangeDay}
                                        onClick={() => { props.nextDayWeek() }} />
                                </Grid>}
                        </Grid>}
                </Grid>}
        </Grid>
    );
}